import React, {useEffect, useState} from 'react';

const STORAGE_KEY = 'cookieNoticeDismissed';

/**
 * Informare generica - nu folosim cookie-uri de tracking/analytics.
 * Autentificarea foloseste localStorage, nu cookie-uri (vezi AuthContext.js).
 * Prima data se arata bannerul complet; dupa ce-l inchizi, ramane doar o
 * bulina "?" permanenta, jos-dreapta, care redeschide bannerul la click.
 */
const CookieNotice = () => {
    const [bannerOpen, setBannerOpen] = useState(() => localStorage.getItem(STORAGE_KEY) !== '1');

    // bannerul e fix, pe toata latimea, jos - fara padding, ar acoperi ultima
    // parte din continutul paginii (ex. butoane/text de la finalul paginii)
    useEffect(() => {
        if (bannerOpen) {
            document.body.style.paddingBottom = '80px';
        } else {
            document.body.style.paddingBottom = '';
        }
        return () => {
            document.body.style.paddingBottom = '';
        };
    }, [bannerOpen]);

    const handleDismiss = () => {
        localStorage.setItem(STORAGE_KEY, '1');
        setBannerOpen(false);
    };

    if (!bannerOpen) {
        return (
            <button
                type="button"
                onClick={() => setBannerOpen(true)}
                title="Informații despre cookie-uri"
                aria-label="Informații despre cookie-uri"
                style={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    zIndex: 2000,
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: '#1f2937',
                    color: '#f3f4f6',
                    border: 'none',
                    fontSize: 18,
                    fontWeight: 'bold',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    cursor: 'pointer',
                }}
            >
                ?
            </button>
        );
    }

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 2000,
                background: '#1f2937',
                color: '#f3f4f6',
                padding: '14px 20px',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                fontSize: 14,
                boxShadow: '0 -2px 8px rgba(0,0,0,0.2)',
            }}
        >
            <span style={{flex: '1 1 320px'}}>
                Acest site nu folosește cookie-uri de tracking sau analytics. Autentificarea se face prin stocare locală în browser (localStorage),
                nu prin cookie-uri. Singura informație reținută local e faptul că ai văzut acest mesaj.
                {' '}<a href="https://www.webnou.ro/produse/mobile/app-webnou-ro/politica-de-confidentialitate.html" target="_blank" rel="noopener noreferrer" style={{color: '#93c5fd'}}>Detalii (GDPR)</a>
            </span>
            <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleDismiss}
                style={{flex: '0 0 auto'}}
            >
                Am înțeles
            </button>
        </div>
    );
};

export default CookieNotice;
